import React from 'react';
import { useTranslation } from 'react-i18next';
import { Column, Container, Row } from 'Core/components/Layout';
import { getAppConfig } from 'Core/config/appConfig';
import logoStripe from 'url:Images/powered_by_stripe.svg';
import logoHearCom from 'url:Images/logo_hearcom_payment-portal.svg';
import logoAudibene from 'url:Images/logo-de.svg';

const logos = {
  us: logoHearCom,
  ca: logoHearCom,
  de: logoAudibene,
  nl: logoAudibene,
  fr: logoAudibene,
};
const stripeLink = {
  us: 'https://stripe.com/',
  ca: 'https://stripe.com/en-ca',
  de: 'https://stripe.com/de',
  nl: 'https://stripe.com/en-nl',
  fr: 'https://stripe.com/fr',
};

const HeaderBanner = ({ hideStripeLogo = false }) => {
  const { t } = useTranslation();
  const { country } = getAppConfig();

  return (
    <Container className="!mb-0">
      <Row className="!pt-6 !flex-nowrap justify-between items-end">
        <Column noFlex className="!flex-none !grow-0 md:!flex-col-4">
          <img
            src={logos[country]}
            alt="Payment Portal Logo"
            className="h-7 md:h-[35px] shrink-0"
          />
        </Column>
        <Column noFlex className="!flex-1 !min-w-0 md:!flex-col-4 !text-right">
          <h1 className="!text-sm sm:!text-sm md:!text-base lg:!text-xl truncate mb-0">
            {t('common.website-claim')}
          </h1>
        </Column>

        {!hideStripeLogo && (
          <Column noFlex className="!flex-none !grow-0 md:!flex-col-4 !pr-4 !flex !justify-end">
            <a href={stripeLink[country]} target="_blank" rel="noreferrer">
              <img src={logoStripe} alt="powered by stripe" className="h-6 md:h-[28px] shrink-0" />
            </a>
          </Column>
        )}
      </Row>
    </Container>
  );
};

export default HeaderBanner;
